import { Controller } from "@hotwired/stimulus"

// Loads a read-only detail card for the invoice number being keyed in the
// lockbox entry form. On (debounced) input it swaps the preview turbo-frame's
// src to the previews endpoint; a blank number clears the frame. Mirrors the
// frame-src-swap pattern in terms_of_usage_form_controller.
//
// The selected bank rides along in the query string so the card can flag an
// invoice whose currency doesn't match the account the batch is being deposited
// into. Changing the bank re-requests the card immediately (no debounce — it's a
// click, not typing) so that notice never describes a stale selection.
export default class extends Controller {
  static targets = ["preview", "bankAccount"]
  static values = { url: String, delay: { type: Number, default: 300 } }

  lookup(event) {
    const number = event.target.value.trim()
    clearTimeout(this.timeout)
    if (number === "") {
      this.#clear()
      return
    }
    this.number = number
    this.timeout = setTimeout(() => this.#load(number), this.delayValue)
  }

  bankChanged() {
    if (this.number) this.#load(this.number)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  #load(number) {
    if (!this.hasPreviewTarget) return
    const params = new URLSearchParams({ number })
    const bankAccountId = this.#bankAccountId()
    if (bankAccountId) params.set("bank_account_id", bankAccountId)
    this.previewTarget.src = `${this.urlValue}?${params}`
  }

  #bankAccountId() {
    return this.hasBankAccountTarget ? this.bankAccountTarget.value : null
  }

  #clear() {
    this.number = null
    if (!this.hasPreviewTarget) return
    this.previewTarget.removeAttribute("src")
    this.previewTarget.innerHTML = ""
  }
}
